import {
  ApiRequest,
  GetBaseServiceFunctions,
  queryClient,
} from '../baseService'

const BaseRoute = 'app/report-corrections'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function UpdateNote(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/note`, data)
}

function UpdateStatus(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/status`, data)
}
function ExportSearchResult(payload = {}) {
  return ApiRequest.post(`${BaseRoute}/export`, payload, {
    responseType: 'arraybuffer',
  })
}

const API = {
  ...baseFunctions,
  UpdateNote,
  UpdateStatus,
  ExportSearchResult,
}

export default API
